
export enum TipoLocomocao {
  Carro = 'Carro',
  Moto = 'Moto',
  Publico = 'Publico',
  Bike = 'Bike',
  Ape = 'Ape',
  Outro = 'Outro',
}
